<template>
  <v-app fill-height>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>
